export default __webpack_public_path__ + "static/media/shop.db03ed2b.svg";